import React from 'react';

import { ScreenTitle } from '../../../../components/atoms';
import { withSnackbar } from 'notistack';
import './style.scss';

const CourseManual = ({
  enqueueSnackbar,
}) => {

  return (
    <>
      <ScreenTitle title='Dashboard' subTitle='Course Manual'/>

      <iframe
        src='https://drive.google.com/viewerng/viewer?url=http://18.223.129.36/preparetopass/uploads/pdf/essentials.pdf?pid=explorer&efh=false&a=v&chrome=false&embedded=true'
        className='iframe'
        title='Course Manual'
        style={{ border: 0 }}
      ></iframe>

    </>
  );
};

export default withSnackbar(CourseManual);
